export default __webpack_public_path__ + "static/media/HOTCROSS.9d6bde24.svg";